import { render, staticRenderFns } from "./waterColorful.vue?vue&type=template&id=e6f5a374"
import script from "./waterColorful.vue?vue&type=script&lang=js"
export * from "./waterColorful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports